export default "__VITE_ASSET__CfwRMR6p__"